export default __webpack_public_path__ + "static/media/islamic institute for education logo1.6dbf4f6d.jfif";